import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import IdntyDownloadView from '../presentational/IdntyDownloadView';

const IdntyRegistrationConfirmationContainer = () => {
  const isComplete = useSelector((state) => state.registration.ui.isComplete);

  if (!isComplete) {
    return <Redirect to='/signup/idnty' />;
  }

  return (
    <IdntyDownloadView />
  );
};

export default IdntyRegistrationConfirmationContainer;
